export default __webpack_public_path__ + "static/media/lockincircle.5f71204f.svg";